<template>
    <div class="header-serials">
        <div class="img-campaigns">
            <img :src="serialModel.campaignImgUrl" />
        </div>
        <div class="title-campaign">
            {{ serialModel.campaignName }}
        </div>
        <div class="point-campaign">
            <span>ใช้ {{ serialModel.pointPerUnit }} คะแนน</span
            ><img src="@/assets/profile/point-darkgray.svg" alt="" />
        </div>
    </div>
</template>
<script>
import Moment from "moment";
//helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
//component
import TimerHelper from "@/helper/TimerHelper.js";

export default {
    name: "SerialHeader",
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            timer: new TimerHelper(),

            tag: null,

            busModal: null,
        };
    },
    created: function () {
        // this.initial();
    },
    methods: {
        initial: function () {
            if (this.timer.interval) this.timer.stopTimer();

            this.timer.initialTimer(this.serialModel.expireIn);
            if (this.serialModel.showTimer)
                this.timer.runTimer(this.serialExpired);
        },
        serialExpired: function () {
            this.controller.sendSerialExpire();
        },
        getRedeemMessageOver: function () {
            Moment.locale("th");
            var dateOver =
                this.serialModel.redeemTimestamp + this.serialModel.expireIn;
            var result = Moment.unix(dateOver).utc();
            var year = result.format("YYY");
            year = result.get("year") + 543;

            var day = result.format("DD");
            var month = result.format("MMM");
            var date = `${day} ${month} ${year.toString().substring(2, 4)}`;

            return Util.stringFormat(date);
        },
        getRedeemMessageEX: function () {
            Moment.locale("th");
            var expireDate = this.timer.currentTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format("YYY");
            year = result.get("year") + 543;

            var day = result.format("DD");
            var month = result.format("MMM");
            var date = `${day} ${month} ${year.toString().substring(2, 4)}`;

            return Util.stringFormat(date);
        },
        getRedeemMessage: function () {
            Moment.locale("th");
            var expireDate = this.serialModel.redeemTimestamp;
            var result = Moment.unix(expireDate).utc();
            var year = result.format("YYY");
            year = result.get("year") + 543;

            var day = result.format("DD");
            var month = result.format("MMM");
            var date = `${day} ${month} ${year
                .toString()
                .substring(2, 4)}, ${result.format("HH:mm")}`;

            return Util.stringFormat(date);
        },
        getExpire: function () {
            Moment.locale("th");
            var Ex =
                this.serialModel.expireDate +
                this.serialModel.daysValidAfterExpire * 86400;
            var result = Moment.unix(Ex).utc();
            var year = result.format("YYY");
            year = result.get("year") + 543;

            var day = result.format("DD");
            var month = result.format("MMM");
            var date = `${day} ${month} ${year.toString().substring(2, 4)}`;

            return Util.stringFormat(date);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/_mixin.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
#serial_header_wrapper {
    @extend %display-flex;
    padding: 10px;
    margin-bottom: 7px;

    .serial-header-col {
        width: 50%;
        flex: 0 0 50%;
        margin: {
            top: auto;
            bottom: auto;
        }
    }

    #serial_campaign_img {
        @include baseRatioImg(66.67%);
        border-radius: 10px;
    }

    #serial_campaign_info {
        padding: {
            left: 20px;
        }

        #serial_campaign {
            font-size: 1.45rem;
            font-weight: normal;
            line-height: 0.9;
        }
    }
}
.header-serials {
    margin-bottom: 15px;
    .img-campaigns {
        overflow: hidden;
        float: left;
        width: 54vw;
        position: absolute;
        top: -46px;
        left: 50%;
        z-index: 1;
        border-radius: 20px;
        transform: translate(-50%, -50%);
        padding: 0;
        img {
            width: 100%;
            overflow: hidden;
        }
    }
    .title-campaign {
        font-size: 16px;
        color: $color-text;
        font-weight: 100;
        line-height: 23px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // -webkit-box-orient: vertical;
        // display: -webkit-box;
        // -webkit-line-clamp: 2;
        padding-top: calc(27vw - 30px);
    }
    .point-campaign {
        font-size: 16px;
        color: $color-brown-600;
        font-weight: 100;
        line-height: 23px;
        font-family: "PromptSemiBold";
        border-bottom: solid 2px $color-light-grey-500;
        padding: 10px 0;
        span {
            margin-right: 5px;
        }
    }

    .text-detail {
        color: #707070;
        font-size: 18px;
        font-weight: 200;
    }
    .text-detail-date {
        color: $color-text-light;
        font-size: 16px;
        font-weight: 200;
    }

    .text-time {
        color: #e73030;
        font-size: 16px;
    }

    .serial-expired {
        color: #e73030;
        font-size: 16px;
    }
}
</style>
